/** One survey contract for the authenticated product surfaces and server. */
export const TRIAL_EXIT_QUESTION = 'Was anything getting in your way?';
export const TRIAL_EXIT_REASONS = ['unclear_next_step', 'something_not_working', 'finished_for_now'];
export const TRIAL_EXIT_REASON_OPTIONS = [
    { id: 'unclear_next_step', label: 'I wasn’t sure what to do' },
    { id: 'something_not_working', label: 'Something wasn’t working' },
    { id: 'finished_for_now', label: 'No, I was just finished' },
];
export const TRIAL_EXIT_SCREENS = ['team_review_new_issue', 'extension_new_issue', 'extension_sidebar', 'extension_side_panel', 'dashboard_new_issue'];
/** Surface adapters supply their token source; account identity is validated by the server too. */
export function createTrialExitFeedbackTransport({ apiOrigin, getToken, request = globalThis.fetch }) {
    async function post(action, body, signal) {
        const token = await getToken();
        if (signal?.aborted)
            throw new DOMException('Request aborted', 'AbortError');
        if (!token)
            throw new Error('Feedback requires a signed-in account.');
        const response = await request(`${apiOrigin.replace(/\/$/, '')}/api/trial-exit-feedback/${action}`, {
            method: 'POST', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(body), signal, keepalive: action !== 'claim',
        });
        if (!response.ok)
            throw new Error('Feedback could not be saved.');
        const result = await response.json();
        if (!result || !('data' in result))
            throw new Error('Feedback returned an invalid response.');
        return result.data;
    }
    return {
        claim: (body, signal) => post('claim', body, signal),
        shown: (body, signal) => post('shown', body, signal),
        respond: (body, signal) => post('respond', body, signal),
    };
}
//# sourceMappingURL=trialExitFeedback.js.map